import type { RetryEligibility } from "@investhinks/api-client";

export type RetryButtonState =
  | { show: false }
  | { show: true; enabled: true; hintKey: null }
  | { show: true; enabled: false; hintKey: "dailyLimit" | "permanent" | "noCard" | "notBillable"; nextAllowedAt?: string | null };

/** Maps the server's retry eligibility to what the retry button shows. */
export function retryButtonState(eligibility: RetryEligibility | null | undefined): RetryButtonState {
  const decision = eligibility?.decision;
  if (!eligibility || !decision || decision.why === "nothing_to_retry") return { show: false };
  if (decision.allowed) return { show: true, enabled: true, hintKey: null };
  switch (decision.why) {
    case "daily_limit":
      return { show: true, enabled: false, hintKey: "dailyLimit", nextAllowedAt: decision.nextAllowedAt };
    case "permanent":
      return { show: true, enabled: false, hintKey: "permanent" };
    case "no_card":
      return { show: true, enabled: false, hintKey: "noCard" };
    default:
      return { show: true, enabled: false, hintKey: "notBillable" };
  }
}
